import { App } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(App)`
  height: 100%;
  min-width: 420px;
`;
